<template>
  <div class="toggle">
    <button
      class="toggle__button"
      v-for="option in options"
      :class="{'is-active': isActive(option)}"
      :key="option"
      @click="$emit('change', option)"
    >{{ option }}</button>
  </div>
</template>

<script>
export default {
  name: 'Toggle',
  props: {
    value: String,
    options: {
      type: Array,
      required: true,
    },
  },
  methods: {
    isActive(option) {
      return this.value.toLowerCase() === option.toLowerCase();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.toggle {
  border: solid 2px var(--color-dark);
  border-radius: var(--radius);
  display: inline-flex;
  overflow: hidden;
  &__button {
    padding: 5px 10px;
    border-radius: 0;
    &:not(.is-active) {
      color: var(--color-dark);
      background-color: var(--color-light);
    }
    &.is-active {
      pointer-events: none;
    }
  }
}
</style>
